import { render } from "./director_info.html?vue&type=template&id=36ccd52c&external"
import script from "./director_info.js?vue&type=script&lang=js&external"
export * from "./director_info.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__